// extracted by mini-css-extract-plugin
export default {"main":"navbar_main__z3EvI","logo":"navbar_logo__bKPrp","heading":"navbar_heading__e6jJE"};